import { isNotNilOrEmpty } from 'shared/utils/ramda'
import { addTestId } from 'shared/utils/tests'

import { PageProductTypes } from '../../../types/products'
import { getProductPrices, pricePerGrammar } from '../../../utils/products'
import {
  getQuantityUnit,
  multiplyingPriceByQuantityJump
} from '../../../utils/quantity'

import styles from './ProductPrices.module.scss'

const ProductPrices = ({
  product,
  quantityJump
}: {
  product: PageProductTypes
  quantityJump: number
}) => {
  const { pricePerUnit, mainUnit } = product

  const unitPerPrice: string = mainUnit?.name || ''

  const { currentPrice, lowestPrice30days, promoPrice, defaultPrice } =
    getProductPrices(product)

  return (
    <div>
      <div className={styles.pricesWrapper}>
        <div className={styles.prices}>
          <div className={styles.price}>
            <span className={styles.priceLabel}>Cena aktualna</span>
            <p
              className={styles.currentPrice}
              {...addTestId('product-page-current-price')}
              dangerouslySetInnerHTML={{
                __html: `${multiplyingPriceByQuantityJump(
                  currentPrice,
                  quantityJump
                )} / ${getQuantityUnit(quantityJump)}`
              }}
            />
          </div>
          {isNotNilOrEmpty(promoPrice) && (
            <div className={styles.price}>
              <span className={styles.priceLabel}>Cena regularna</span>
              <p
                className={styles.priceBeforeDiscount}
                dangerouslySetInnerHTML={{
                  __html: `${multiplyingPriceByQuantityJump(
                    defaultPrice,
                    quantityJump
                  )}`
                }}
                {...addTestId('product-page-old-price')}
              />
            </div>
          )}
        </div>
        <p
          className={styles.pricePerGrammar}
          dangerouslySetInnerHTML={{
            __html: pricePerGrammar(pricePerUnit, unitPerPrice)
          }}
          {...addTestId('product-page-price-per-grammar')}
        />
      </div>
      {lowestPrice30days && (
        <div className={styles.lastThirtyDaysPrice}>
          Najniższa cena z 30 dni przed obniżką:{' '}
          <span
            {...addTestId('product-page-lowest-price')}
            dangerouslySetInnerHTML={{ __html: lowestPrice30days }}
          />
        </div>
      )}
    </div>
  )
}

export default ProductPrices
